import 'ui-theme/components/issue-item/js/issue-item';

(function ($, UX) {
    const {issueItem} = UX;
    const {truncate, controls, truncateOptions} = issueItem;
    const options = {
        seeMoreIcon: null,
        lines: 2,
        seeLessIcon: null,
        seeMoreIconMobile: null,
    };
    const $window = $(window);
    const $letterAuthors = $('.issue-item__letter .loa');
    const $landingTeaser = $('.top-content--landing .loa');
    issueItem.truncateOptions = {...truncateOptions, ...options};
    issueItem.truncate = () => {
        truncate();
        issueItem.checkIsMobile();

        const {seeMoreText, seeLessText} = issueItem;
        const options = {
            ...issueItem.truncateOptions,
            ...{lines: 3},
            seeLessText,
            seeMoreText,
        };
        $letterAuthors.not("[data-truncate='none']").truncate(options);
        options.lines = issueItem.isMobile ? 2 : 1;
        $landingTeaser.not("[data-truncate='none']").truncate(options);
    };

    issueItem.controls = () => {
        controls();
        const {seeMoreText, seeLessText} = issueItem;
        const options = {
            ...issueItem.truncateOptions,
            ...{lines: 3},
            seeLessText,
            seeMoreText,
        };
        $window.on('resized orientationchange', function () {
            issueItem.checkIsMobile();
            $letterAuthors.not("[data-truncate='none']").truncate();
            options.lines = issueItem.isMobile ? 2 : 1;
            $landingTeaser.not("[data-truncate='none']").truncate(options);
        });
    };

    issueItem.checkIsMobile = () => {
        issueItem.isMobile = $window.width() < UX.grid.screenSm;
    };

    UX.issueItem = issueItem;
})($, UX);
